import { useEffect, useRef } from 'react';
import { apiGet } from './api-client';

export type TermsTemplateKind = 'invoice' | 'offer' | 'purchase_order';

export interface TermsTemplate {
  id: string;
  name: string;
  kind: TermsTemplateKind;
  paymentTerms: string;
  delivery: string;
  notice: string;
  acceptance: string;
  validDays: number;
}

export function useTermsSeed(kind: TermsTemplateKind, enabled: boolean, apply: (row: TermsTemplate) => void) {
  const started = useRef(false);
  const applyRef = useRef(apply);
  applyRef.current = apply;
  useEffect(() => {
    if (!enabled || started.current) return;
    started.current = true;
    let live = true;
    void apiGet<{ settings?: { termsTemplates?: TermsTemplate[] } }>('/api/settings').then((data) => {
      if (!live) return;
      const row = (data.settings?.termsTemplates || []).find((item) => item.kind === kind);
      if (row) applyRef.current(row);
    }).catch(() => undefined);
    return () => { live = false; };
  }, [enabled, kind]);
}
